import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import HeadlineWidget from "../../Widgets/HeadlineWidget/HeadlineWidgetClass";
import SectionContentWidget from "../../Widgets/SectionContentWidget/SectionContentWidgetClass";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";
import {
  defaultPageProperties,
  defaultPageInitialContent,
} from "../_defaultPageEditingConfig";

Scrivito.provideEditingConfig("Root", {
  title: "Root",
  hideInSelectionDialogs: true,
  attributes: localizeAttrList(
    [...defaultPageProperties, ...metadataPropertiesGroup.properties],
    "Root"
  ),
  properties: ["title", "hideInNavigation"],
  propertiesGroups: [socialCardsPropertiesGroup, metadataPropertiesGroup],
  initialContent: {
    ...defaultPageInitialContent,
    title: "Lorem ipsum",
    body: [
      new SectionContentWidget({
        content: [new HeadlineWidget({ style: "h1" })],
      }),
    ],
    ...metadataInitialContent,
  },
});
